import { useMemo } from 'react';

import useWindowSize from 'hooks/common/useWindowSize';

interface IUseEraserSizes {
  height: number;
  width: number;
}

function useEraserSizes(passedImage?: HTMLImageElement | HTMLCanvasElement | IUseEraserSizes) {
  const { width: windowWidth, height: windowHeight } = useWindowSize();

  const { passedImageWidth, passedImageHeight } = useMemo(() => ({
    passedImageWidth: Number(passedImage?.width || 0),
    passedImageHeight: Number(passedImage?.height || 0),
  }), [passedImage]);

  const ratio = useMemo(() => Math.min(
    (windowWidth * 0.5) / (passedImageWidth || 1),
    (windowHeight * 0.7) / (passedImageHeight || 1),
  ) || 0, [passedImageWidth, passedImageHeight, windowHeight, windowWidth]);

  return useMemo(() => [
    passedImageWidth * ratio,
    passedImageHeight * ratio,
  ], [ratio, passedImageWidth, passedImageHeight]);
}

export default useEraserSizes;
